module.exports = __webpack_public_path__ + "static/sport/img-text-pc.1273631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/img-text-pc.png
// module id = b7BK
// module chunks = 0